"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Alert = void 0;
var _Close = _interopRequireDefault(require("@tvg/fuse-icons/lib/Close"));
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledAlert = require("./styled-alert");
var _excluded = ["banner", "children", "closeCallback", "dataTestId", "heading", "message", "showIcon", "size", "variant"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef,
  useCallback = _react["default"].useCallback;
var propTypes = {
  banner: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  closeCallback: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  heading: _propTypes["default"].string,
  message: _propTypes["default"].string,
  showIcon: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(['small', 'responsive']),
  variant: _propTypes["default"].oneOf(['warning', 'error', 'success', 'information'])
};
var defaultProps = {
  banner: false,
  children: undefined,
  closeCallback: function closeCallback() {},
  dataTestId: undefined,
  heading: '',
  message: '',
  showIcon: true,
  size: 'responsive',
  variant: 'information'
};
var AlertComponent = exports.Alert = forwardRef(function (_ref, ref) {
  var banner = _ref.banner,
    children = _ref.children,
    closeCallback = _ref.closeCallback,
    dataTestId = _ref.dataTestId,
    heading = _ref.heading,
    message = _ref.message,
    showIcon = _ref.showIcon,
    size = _ref.size,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var others = _extends({}, (_objectDestructuringEmpty(props), props));
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isClosed = _React$useState2[0],
    setIsClosed = _React$useState2[1];
  var closeClickHandler = useCallback(function (e) {
    setIsClosed(true);
    closeCallback(e);
  }, [isClosed]);
  return !isClosed && /*#__PURE__*/_react["default"].createElement(_styledAlert.StyledAlert, _extends({
    banner: banner,
    "data-testid": dataTestId || 'fuse-alert',
    ref: ref,
    size: size,
    variant: variant
  }, others), /*#__PURE__*/_react["default"].createElement(_styledAlert.StyledAlertContentContainer, {
    xxs: 11,
    l: 10,
    variant: variant,
    showIcon: showIcon,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_styledAlert.StyledAlertContent, null, /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, "An alert has occurred - ", variant), heading && /*#__PURE__*/_react["default"].createElement(_styledAlert.StyledAlertHeading, null, heading), message && /*#__PURE__*/_react["default"].createElement(_styledAlert.StyledAlertMessage, null, message), children)), banner && /*#__PURE__*/_react["default"].createElement(_styledAlert.StyledCloseButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_styledAlert.StyledIconButton, {
    icon: /*#__PURE__*/_react["default"].createElement(_Close["default"], null),
    callback: function callback(e) {
      return closeClickHandler(e);
    },
    srLabel: "Close ".concat(variant, " dialog")
  })));
});
AlertComponent.propTypes = propTypes;
AlertComponent.defaultProps = defaultProps;
var _default = exports["default"] = AlertComponent;